<template>
  <div>
    <dialog-handler-error
      :openDialog="isOpenDialog"
      :content="content"
      v-if="isEnableDialog"
    ></dialog-handler-error>
  </div>
</template>

<script>
import userService from "../../services/userService";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import authenService from "../../services/authenService";
import h from "../../services/h";
import constants from "../../constants";
import DialogHandlerError from "../../components/DialogHandlerError";
import errorMessageFilter from "../../filters/errorMessageFilter";
import globalConfigService from "../../services/globalConfigService";
import tenantService from "../../services/tenantService";

export default {
  name: "before-enter-app-page",
  components: {DialogHandlerError},

  data() {
    return {
      userDeptRoles: null,
      userData: null,
      globalDeptRoles: null,
      content: null,
      isOpenDialog: false,
      isEnableDialog: false
    };
  },

  watch: {
    isOpenDialog(newValue) {
      newValue && (this.isEnableDialog = newValue);
    }
  },

  created() {
    this.loadCommonUserInfo()
      .then(() => {
        this.loadGlobalConfig();
        this.loadDeptRoleGlobal();
        this.loadTenantInfo();
      })
      .finally(() => this.doRouting());

  },

  methods: {
    loadGlobalConfig(){
      globalConfigService.findByCode(constants.GLOBAL_CONFIG.LANH_DAO_EDIT_NODE).then(res => {
        let globalConfigEditNode = false;
        if(res && res.data && res.data.status === constants.STATUS_.ACTIVE) {
          globalConfigEditNode = true;
        } else {
          globalConfigEditNode = false;
        }
        authenService.storeGlobalConfigEditNode(globalConfigEditNode);
      }).then(() => {
        globalConfigService.findByCode(constants.GLOBAL_CONFIG.SOAN_THAO_VB).then(res => {
          let globalConfigEditNodeSoanThaoVb = false;
          if(res && res.data && res.data.status === constants.STATUS_.ACTIVE) {
            globalConfigEditNodeSoanThaoVb = true;
          } else {
            globalConfigEditNodeSoanThaoVb = false;
          }
          authenService.storeGlobalConfigEditNodeSoanThaoVb(globalConfigEditNodeSoanThaoVb);
        })
      }).then(() => {
        globalConfigService.findByCode(constants.GLOBAL_CONFIG.CONFIG_SIGNING).then(res => {
          let globalConfigSigning = false;
          if(res && res.data && res.data.status === constants.STATUS_.ACTIVE) {
            globalConfigSigning = true;
          } else {
            globalConfigSigning = false;
          }
          authenService.storeGlobalConfigSigning(globalConfigSigning);
        })
      })
    },

    handleUserDeptRoleNotExists() {
      this.content = errorMessageFilter({
        errorCode: "authenticate.userDeptRoleNotExists"
      });
      this.isOpenDialog = true;
    },

    loadCommonUserInfo() {
      return userService
        .get()
        .then(response => response.data)
        .then(user =>
          userDeptRoleViewService
            .findAllByCurrentUser()
            .then(response => {
              this.userDeptRoles = response.data || [];
              this.userData = user || {};
              return new Promise((resolve, reject) => {
                if (this.userDeptRoles && this.userDeptRoles.length) {
                  resolve({user: user, userDeptRoles: this.userDeptRoles});
                } else {
                  this.handleUserDeptRoleNotExists();
                  reject(
                    new Error({error: "authenticate.userDeptRoleNotExists"})
                  );
                }
              });
            })
            .then(loginPayload => this.$store.commit("login", loginPayload))
        );
    },

    loadDeptRoleGlobal() {
      return userDeptRoleViewService
            .findAllByCurrentDeptRole()
            .then(response => {
              this.globalDeptRoles = response.data;
              // console.log('this.globalDeptRoles',this.globalDeptRoles)
              this.globalDeptRoles && this.$store.commit("globalRoles", this.globalDeptRoles);
              return this.globalDeptRoles;
            });
    },

    loadTenantInfo() {
      if(!this.userData || !this.userData.tenantCode) return;
      return tenantService.findByCode(this.userData.tenantCode)
            .then(response => {
              this.tenantData = response.data;
              this.tenantData && this.$store.commit("setTenantData", this.tenantData);
              return this.tenantData;
            });
    },

    getStateURLBeforeLogin() {
      let stateURLBeforeLoginJsonStr = authenService.get(
        constants.STATE_URL_BEFORE_LOGIN
      );
      authenService.remove(constants.STATE_URL_BEFORE_LOGIN);
      return stateURLBeforeLoginJsonStr
        ? JSON.parse(stateURLBeforeLoginJsonStr)
        : null;
    },

    defaultRouting() {
      let defaultUserDeptRole =
        h.find(
          this.userDeptRoles,
          item =>
            item.isDefaultRole === constants.TRUE &&
            item.status === constants.USER_DEPT_ROLE.STATUS.ACTIVE
        ) || this.userDeptRoles[0];

      this.$store.commit("changeUserDeptRole", defaultUserDeptRole.id);
      this.$router.replace({
        name: "dashboard",
        params: {userDeptRoleId: defaultUserDeptRole.id}
      });
    },

    doRouting() {
      let stateURLBeforeLogin = this.getStateURLBeforeLogin();
      if (
        stateURLBeforeLogin &&
        (stateURLBeforeLogin.ROUTER_NAME === "detailRouting" ||
          (stateURLBeforeLogin.PARAMS &&
            stateURLBeforeLogin.PARAMS.userDeptRoleId &&
            h.exists(
              this.userDeptRoles,
              item => item.id === stateURLBeforeLogin.PARAMS.userDeptRoleId
            )))
      ) {
        this.$router.replace({
          name: stateURLBeforeLogin.ROUTER_NAME,
          // path: stateURLBeforeLogin.URL,
          query: stateURLBeforeLogin.QUERY,
          params: stateURLBeforeLogin.PARAMS
        });
      } else {
        this.defaultRouting();
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/login/before-enter-app-page.vue